import { ApiResponse } from "../../models/app/apiResponse";
import DashboardRatingResponse from "../../models/dashboard/dashboardRatingResponse";
import api_poslovni_imenik from "./api_poslovni_imenik";

export const getCompanyRatingForDashboard: any = async () => {
  return api_poslovni_imenik.get(
    "/company-rating/get-company-rating-for-dashboard"
  ) as Promise<ApiResponse<DashboardRatingResponse | null>>;
};
